<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
    <div class="close_btn" v-on:click="Close()"></div>
    <br />
  </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  components: { PageLoader },
  props: ["Account"],
  data() {
    return {
      isBillingDifferent: true,
      ValidationResult: {},
    };
  },
  methods: {
    ShowWufoo() {
      var _this = this;
      var k1vh58nv1osavlv;
      (function (d, t) {
        var s = d.createElement(t),
          options = {
            userName: "evf",
            formHash: "k1vh58nv1osavlv",
            autoResize: true,
            height: "1119",
            async: true,
            host: "wufoo.com",
            header: "show",
            ssl: true,
            defaultValues:
              "field3=" +
              _this.Account.primaryContact.firstName +
              "&field4=" +
              _this.Account.primaryContact.lastName +
              "&field5=" +
              _this.Account.emailAddress +
              "&field6=" +
              _this.Account.primaryContact.officeLocation.streetAddress +
              "&field25=Order Frame Kit&field8=" +
              _this.Account.primaryContact.officeLocation.city +
              "&field9=" +
              _this.Account.primaryContact.officeLocation.state +
              "&field10=" +
              _this.Account.primaryContact.officeLocation.zip +
              "&field12=&field13=&field14=&field15=&field16=&field19=&field23=Frame_Service_Fee__c&field20=1&field21=" +
              _this.Account.portalUserSalesforceId +
              "&",
          };
        s.src =
          ("https:" == d.location.protocol ? "https://" : "http://") +
          "www.wufoo.com/scripts/embed/form.js";
        s.onload = s.onreadystatechange = function () {
          var rs = this.readyState;
          if (rs) if (rs != "complete") if (rs != "loaded") return;
          try {
            k1vh58nv1osavlv = new WufooForm();
            k1vh58nv1osavlv.initialize(options);
            k1vh58nv1osavlv.display();
          } catch (e) {}
        };
        var scr = d.getElementsByTagName(t)[0],
          par = scr.parentNode;
        par.insertBefore(s, scr);
      })(document, "script");

      // MODAL DISPLAY
      document.body.classList.add("body-overflow");
    },
    Close() {
      document.body.classList.remove("body-overflow");
      this.$emit("exitModal");
    },
  },
  created() {
    this.ShowWufoo();
  },
};
</script>



// WEBPACK FOOTER //
// FrameShippingBilling.vue?477bbbfa